import React from 'react';
import HeaderMenuModern from './components/HeaderMenuModern';
import Footer from './Footer';
import './Layout.css';

function Layout({ children, headerProps }) {
  return (
    <div className="layout-root">
      <HeaderMenuModern {...(headerProps || {})} />
      <div className="layout-main">
        <main className="layout-content">{children}</main>
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
